import React, { useState } from 'react';
import AuctionItem from '../AuctionItem/AuctionItem';
import Spinner from '../Spinner/Spinner';

const AuctionList = ({
  auctions,
  totalResults,
  pageSize,
  pageIndex,
  onPageChange,
  loading,
  auctionType,
}) => {
  const [inputPage, setInputPage] = useState(pageIndex + 1);
  const totalPages = Math.ceil(totalResults / pageSize);

  const handleNextPage = () => {
    if (pageIndex < totalPages - 1) {
      onPageChange(pageIndex + 1);
    }
  };

  const handlePrevPage = () => {
    if (pageIndex > 0) {
      onPageChange(pageIndex - 1);
    }
  };

  const handlePageInput = (e) => {
    const value = parseInt(e.target.value, 10);
    if (value >= 1 && value <= totalPages) {
      setInputPage(value);
    }
  };

  const handleInputBlur = () => {
    const page = Math.max(1, Math.min(inputPage, totalPages)) - 1;
    onPageChange(page);
  };

  return (
    <div className="w-full">
      {loading ? (
        <div className="flex flex-col items-center justify-center py-12">
          <Spinner />
          <p className="text-gray-500 mt-4">Se încarcă licitațiile...</p>
        </div>
      ) : (
        <>
          <div className="flex flex-col gap-6">
            {auctions.map((auction, index) => (
              <React.Fragment key={index}>
                <AuctionItem auction={auction} auctionType={auctionType} />
                {index < auctions.length - 1 && (
                  <hr className="border-t border-dashed border-indigo-200 my-2" />
                )}
              </React.Fragment>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default AuctionList;
